export default function invalid(value = '') {
  if (['', undefined, null].includes(value) || (typeof value === 'object' && Object.keys(value).length === 0)) {
    return false;
  }

  const specialCharacters = ['|', '!', '#', '$', '%', '^', '&', '*', '(', ')', '+', '\\', '-', '[', ']', '{', '}', ';', "'", ':', '"', '/', '<', '>', '?', '`', '~'];

  let containsSpecialChar = false;

  specialCharacters.forEach((char) => {
    if (String(value).includes(char)) {
      containsSpecialChar = true;
    }
  });

  return containsSpecialChar;
}

invalid.message = function message(value, options = {}) {
  const specialCharacters = ['|', '!', '#', '$', '%', '^', '&', '*', '(', ')', '+', '\\', '-', '[', ']', '{', '}', ';', "'", ':', '"', '/', '<', '>', '?', '`', '~'];

  let errorMessage = '';

  specialCharacters.forEach((char) => {
    if (value && value.includes(char)) {
      errorMessage = options.message || `não pode conter o caractere especial "${char}"`;
    }
  });

  return errorMessage || options.message || 'não é válido';
};
